import React from "react";
import ReactMarkdown from "react-markdown";
import { Badge } from "../GraderUI";
import { ProviderStatusBadges } from "./ProviderStatusBadges";
import { ProviderIcon } from "../shared/ProviderIcon";
import {
	PROVIDERS,
	preprocessResponse,
	getRowSourceCount,
} from "./citationGridUtils";

const markdownComponents = {
	a: ({ href, children }) => (
		<a href={href} target="_blank" rel="noopener noreferrer">
			{children}
		</a>
	),
	strong: ({ children }) => <strong>{children}</strong>,
	em: ({ children }) => <em>{children}</em>,
	ul: ({ children }) => <ul>{children}</ul>,
	ol: ({ children }) => <ol>{children}</ol>,
	code: ({ children }) => <code>{children}</code>,
	blockquote: ({ children }) => <blockquote>{children}</blockquote>,
	p: ({ children }) => <p>{children}</p>,
};

function CompareProviderColumn({ provider, result }) {
	const responseText =
		result?.full_response_snippet || result?.response_snippet || "";

	return (
		<div className="citation-compare-modal__column">
			<div className="citation-compare-modal__column-top">
				<div className="citation-compare-modal__column-header">
					<ProviderIcon provider={provider.key} size={20} />
					<span className="citation-compare-modal__provider-name">{provider.name}</span>
				</div>
				{result ? (
					<ProviderStatusBadges result={result} />
				) : (
					<Badge variant="secondary">No response</Badge>
				)}
			</div>

			{result ? (
				<div className="citation-compare-modal__signals">
					<span>
						Domain{" "}
						<span className={result.domain_mentioned ? "check--yes" : "check--no"}>
							{result.domain_mentioned ? "✓" : "✗"}
						</span>
					</span>
					<span>
						Brand{" "}
						<span className={result.brand_mentioned ? "check--yes" : "check--no"}>
							{result.brand_mentioned ? "✓" : "✗"}
						</span>
					</span>
					{result.position != null && <span>Pos #{result.position}</span>}
				</div>
			) : null}

			{responseText ? (
				<div className="grader-dialog__box grader-dialog__box--scroll citation-compare-modal__response">
					<div className="grader-dialog__markdown">
						<ReactMarkdown components={markdownComponents}>
							{preprocessResponse(responseText)}
						</ReactMarkdown>
					</div>
				</div>
			) : (
				<p className="report-section__summary-text">No response available</p>
			)}

			<div className="citation-compare-modal__footer-meta">
				<span>
					Brands:{" "}
					{result?.competitor_brands?.length
						? result.competitor_brands.join(", ")
						: "None"}
				</span>
				<span>Sources: {result ? getRowSourceCount(result) : 0}</span>
			</div>
		</div>
	);
}

export function CitationCompareModal({ queryResult, onClose }) {
	if (!queryResult) return null;

	return (
		<div className="grader-dialog" onClick={onClose} role="presentation">
			<div
				className="grader-dialog__content grader-dialog__content--wide"
				onClick={(e) => e.stopPropagation()}
				role="dialog"
				aria-modal="true"
			>
				<div className="grader-dialog__header">
					<h3 className="grader-dialog__title citation-compare-modal__title">
						Model responses — {queryResult.query}
					</h3>
					<button
						type="button"
						className="grader-dialog__close"
						onClick={onClose}
						aria-label="Close"
					>
						×
					</button>
				</div>

				<div className="citation-compare-modal__grid">
					{PROVIDERS.map((provider) => (
						<CompareProviderColumn
							key={provider.key}
							provider={provider}
							result={queryResult[provider.resultKey]}
						/>
					))}
				</div>
			</div>
		</div>
	);
}

export default CitationCompareModal;
